import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { WindowManagerService } from './service/window-manager.service';
import { Subject, takeUntil } from 'rxjs';
import { MessageBusService } from './service/message-bus.service';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet],
})
export class AppComponent
{

        viewReady = false;
        private readonly _unsubscribeAll: Subject<any> = new Subject<any>();
    
        currentWinName: string | null = null;
    /**
     * Constructor
     */
    constructor(private readonly _windowManager: WindowManagerService, private readonly messageBus: MessageBusService, private readonly router: Router)
    {
        const urlParams = new URLSearchParams(window.location.search);
        const winName = urlParams.get('winName');
        if (winName) {
          sessionStorage.setItem('currentWinName', winName);
        }        

        this.currentWinName = sessionStorage.getItem('currentWinName');

        this.messageBus.listen()
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((msg) => {
          if (msg._to && msg._to !== this.currentWinName) return;

          if (msg.type === 'NAVIGATE' && msg.targetUrl) {
            const current = this.router.url;
            if (current !== msg.targetUrl) {
              this.router.navigateByUrl(msg.targetUrl);
            }
          }      
        });         
    }
}
